export default {
	title: "Dimmy.club",
	desc: "Device mockup generator for your website and app screenshots!"
};
